import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import AlertTitle from '@mui/material/AlertTitle';
import Paper from '@mui/material/Paper';
import bgimg from './bg/1534714_1025_3.jpg'
import bgimgbox from './bg/VergeMobile_jpg.jpg'
import { useFormik } from 'formik';
import * as yup from "yup";
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import { jwtDecode } from "jwt-decode";
import Link from '@mui/material/Link';



const validationSchema = yup
  .object({
    email: yup.string().email().required('Email is required'),
  })
  .required()


export default function SignIn() {
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [snackbarMessage, setSnackbarMessage] = useState('');



  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const response = await axios.post('https://pkclaims.vergemobile.com/api/forgot_password',
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            params: {
              username: values.email,
            }
          },
        );
     

        setSnackbarSeverity('success');
        setSnackbarMessage(`${response.data.message}`);
        setSnackbarOpen(true);

        await new Promise((resolve) => setTimeout(resolve, 1000));
        navigate('/');

      } catch (error) {
        console.error('Error changing password:', error);
        setSnackbarSeverity('error');
        setSnackbarMessage(`${error.response.data.message}`);
        setSnackbarOpen(true);

      }
    },
  });




  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };



  return (
    <>
      <div
        style={{
          backgroundImage: `url(${bgimg})`,
          justifyContent: 'center',
          display: 'flex',
          backgroundSize: "cover",
          height: "100vh",
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          <div
            style={{
              width: '400px',
              backgroundColor: 'white',
              marginTop: '100px',
              marginBottom: '50px',
              padding: '20px',
              // height:'400px'
            }}
          >
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <img src={bgimgbox} alt="Background Image" style={{ height: '70px', width: '100%' }} />
            </div>

            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'left'
              }}
            >
              <Typography component="h1" variant="h5"  sx={{
                display: 'flex', alignItems: 'center', paddingLeft: 1.2, mt: 3, fontWeight: 'bold',
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)'
              }}>
                Forgot Password
              </Typography>
            </div>

            <div
              style={{
                margin: '0px',
                padding:'0px'
              }}>
              <TextField
                margin="normal"
                fullWidth
                id="email"
                label="Email Address*"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                autoComplete="email"
                inputProps={{ maxLength: 50 }}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
         
            </div>

              <div
              style={{
                margin: '0px',
                padding:'0px'
              }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 4, mb: 1, fontWeight: 'bold' }}
                >
                  Send
                </Button>
              </div>
            
             
          </div>
        </form>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
        closeable={false}
      >
        <Alert
          severity={snackbarSeverity}
          variant='filled'
          sx={{ width: '100%' }}
        >
          <AlertTitle>{snackbarSeverity === 'success' ? 'success' : 'Error'}</AlertTitle>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </>
  );
}